import { graphql } from 'gatsby'
import Live from '../layouts/live'

export default Live

export const pageQuery = graphql`
  query {
    allScheduleYaml {
      edges {
        node {
          slug
          datetime:  date
          date(formatString: "ddd, MMM Do")
          time: date(formatString: "h:mm a")
          title
          youtubeid
          description
          speaker {
            name
            company
            id
          }
        }
      }
    }
    allYoutubeVideo(filter: {tags: {in: "2020"}}, sort: {fields: scheduledStartTime, order: ASC}) {
      edges {
        node {
          id
          title
          description
          videoId
          publishedAt
          privacyStatus
          liveBroadcastContent
          scheduledStartTime
          originalID
        }
      }
    }
  }
`
